import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
// import ListDividers from '@material-ui/core/Divider';
import { useForm } from 'react-hook-form';
import AppButton from 'src/components/AppButton';
import AppInput from 'src/components/AppInput';
import AppSelect from 'src/components/AppSelect';
import useScript from 'src/hooks/useScript';
// import FbLogo from 'src/assets/images/fb-logo.svg';
// import GoogleLogo from 'src/assets/images/google-logo.svg';
import { required, phonePattern } from 'src/util/validation';
import { COUNTRY_CODES } from 'src/constants';


const useStyles = makeStyles((theme: Theme) => ({
  label: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500
  },
  footer: {
    fontSize: 12,
    lineHeight: '20px'
  },
  btn: {
    textTransform: 'capitalize',
    padding: `${theme.spacing(0.75)}px ${theme.spacing(3)}px`
  },
  logo: {
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette2.text.subtext}`,
    borderRadius: 4,
    minWidth: 'unset',
    '& img': {
      width: theme.spacing(4),
      height: theme.spacing(4)
    }
  }
}));

interface SigninFormProps {
  onSubmit?: (data: any) => void;
}

const SigninForm: React.FC<SigninFormProps> = ({ onSubmit }) => {
  const root_captcha = useRef<HTMLDivElement>(null);
  const [showSignin, setShowSignin] = useState(true);
  let submitData: any = null;
  useScript(
    "https://1abd0e6918c0.ap-south-1.captcha-sdk.awswaf.com/1abd0e6918c0/_/jsapi.js",
    null
  )
  const classes = useStyles();
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'all',
    defaultValues: {
      code: COUNTRY_CODES[0].value,
      phone_number: ''
    }
  });
  const handleSendOtp = (data: any) => {
    console.log('handleSendOtp=> ', data);
    submitData = data;
    if(onSubmit){
      setShowSignin(false);
      showMyCaptcha();
    }
  };
  // const handleLogin = type => {
  //   console.log(type);
  // };

  async function showMyCaptcha() {
    window.AwsWafCaptcha.renderCaptcha(root_captcha.current as HTMLElement, {
      apiKey: 'SXLqLemnVERPDpEdjEeTW5RPcaOD6t8QisMEva2TNUqOtRvGWXcC0uDnTAAVERZ9cRzrsqeums+Z/xV+KL84YZECb39j/ek1NqbyE92LAhwpaWUue0otkgly74NEVWpW5yHfGQvCJFRMD6y/lOOXoh1O2BBzZrTC2G4X9nc0a3ajunYDCW0tsj22GCjj1jLxZpoKMvOKBxdSrDnyZX4szTHuLZsZbz3G2a/ZDESRwd8z5be62PKU6jTC06CsKjbn3A1rcEEdnC/1/f9ir3dG3Ujkf5wW+E53RPvuTH4OHCr38pTr60BwL2AWmvSzekpICngtbQrJjOZLBuYQ99IGXKEw7Nxllu4S51ueXtZYdrSpcIFB5dUHaq3Igg2eKx5ygdtJQ/SmgKYBOIA79rKXY9xjojX9Ieh2CPB2jks8l0a899FoZxERxJ7RM0Drju8csPytD1CaFc4bBxA7I4YOsDghXw3mFeeFqLlCBXQWvprNyiJy/fhUoLM/rwewF39TrlcZthb1g9bmi9NzqBHh3y+UMfbNS+4K6sHuFa8I4sFW+UJ+RiWiwqbciV9fOjLu6JvohUS+hQ3WpQwejLdbrmFVcf89HUdSJJOowzMjKlOl4Wb/KC2JXTI8z/Mp3qUu/Ml+G3yrzRV7xOoju/ESCiaxbsPtMyIuaT4v9PiEkcA=_0_1',
      onSuccess: captchaExampleSuccessFunction,
      onError: captchaExampleErrorFunction,
      dynamicWidth: true,
      skipTitle: true
    });
  }

  function captchaExampleSuccessFunction(wafToken: string) {
    // Captcha completed. wafToken contains a valid WAF token. Store it for
    // use later or call AwsWafIntegration.fetch() to use it easily.
    // It will expire after a time, so calling AwsWafIntegration.getToken()
    // again is advised if the token is needed later on, outside of using the
    // fetch wrapper.

    // Use WAF token to access protected resources
    setShowSignin(true);
    console.log('eenttere');
    console.log(submitData)
    if (onSubmit) onSubmit(submitData);
  }

  function captchaExampleErrorFunction(error: any) {
    console.log('error', error);
  }

  return (
    <Box>
      <Box p={4}>
        <Typography className={classes.label}>
          Login with mobile number
        </Typography>
        <Box display="flex" gridColumnGap="8px">
          <Box width="15%">
            <AppSelect
              id="code"
              type="text"
              name="code"
              placeholder="Code"
              validation={{
                required
              }}
              error={errors.code}
              control={control}
              py={0}
              options={COUNTRY_CODES}
              showErrorOnTouch={true}
            />
          </Box>
          <Box width="85%">
            <AppInput
              id="mobile"
              type="text"
              name="phone_number"
              placeholder="Enter mobile number"
              validation={{
                required,
                pattern: phonePattern
              }}
              error={errors.phone_number}
              control={control}
              py={0}
              showErrorOnTouch={true}
            />
          </Box>
        </Box>
        {showSignin ? <Box mt={3}>
          <AppButton
            className={clsx('primary', classes.btn)}
            onClick={handleSubmit(handleSendOtp)}
          >
            Send OTP
          </AppButton>
        </Box> : ''}

      </Box>
      <Box width="100px" height="100px" mx={"auto"} {...{ref: root_captcha} as any}></Box>
    </Box>
  );
};

export default SigninForm;
